import { styled } from '@mui/material/styles';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import ShareIcon from '@mui/icons-material/Share';
import BookIcon from '@mui/icons-material/Book';
import SocialBtn from './SocialBtn';
import LinkToListDialog from '../../../../components/shared/Dialog/LinkToListDialog';
import {
  useLikeNoteMutation,
  useUnlikeNoteMutation,
  useSaveNoteMutation,
  useUnsaveNoteMutation,
} from '../../../../store/api/noteApi';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';

const SocialMediaBtnsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '10px 5px 10px 8px',
  fontFamily: 'Raleway',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '18px',
  lineHeight: '21px',
  color: '#AB9178',
  '&:last-child': {
    margin: '0 0 0 auto',
  },
  [theme.breakpoints.down('750')]: {
    padding: '0px 7px 12px 7px',
  },
}));

const ToastContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  '&:last-child': {
    margin: '0 0 0 auto',
  },
});

const LikeNumber = styled('div')({
  marginRight: '15px',
  width: '15px',
});

const LikedByContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '0 0 10px 8px',
  fontFamily: 'Raleway',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '16px',
  color: '000',
  [theme.breakpoints.down('750')]: {
    padding: '0px 7px 12px 0px',
  },
}));

const LikedByFirstUserName = styled('a')({
  textDecoration: 'none',
  cursor: 'pointer',
  color: 'initial',
  fontWeight: '700',
  padding: '0 5px',
});

const LikedByOtherUserName = styled('span')({
  fontWeight: '700',
  padding: '0 5px',
  fontSize: '14px',
  lineHeight: '16px',
});

const NoteSocialSection = ({ noteData, isResponsive }) => {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  const noteId = noteData._id;
  const { likedUsers, savedUsers } = noteData;
  const [likeNote] = useLikeNoteMutation();
  const [unlikeNote] = useUnlikeNoteMutation();
  const [saveNote] = useSaveNoteMutation();
  const [unsaveNote] = useUnsaveNoteMutation();
  const currentUserId = useSelector(selectUser);

  const likeOrUnlike = async () => {
    if (likedUsers.find((ele) => ele._id === currentUserId)) {
      await unlikeNote({ noteId, userId: currentUserId });
    } else {
      await likeNote({ noteId, userId: currentUserId });
    }
  };

  const saveOrUnsave = async () => {
    if (savedUsers.includes(currentUserId)) {
      await unsaveNote({ noteId, userId: currentUserId });
    } else {
      await saveNote({ noteId, userId: currentUserId });
    }
  };
  const isBlock = !currentUserId || !isLogin;
  const clickToast = () => {
    if (isBlock) {
      toast.success('Please Sign in first.');
    }
    return;
  };

  const SocialMediaRelatedContainer = isResponsive
    ? styled('div')(({ theme }) => ({
        [theme.breakpoints.up(750)]: {
          display: 'none',
        },
        [theme.breakpoints.down(750)]: {
          borderBottom: '2px solid #AB9178',
        },
      }))
    : styled('div')(({ theme }) => ({
        [theme.breakpoints.down(750)]: {
          display: 'none ',
        },
      }));
  return (
    <SocialMediaRelatedContainer>
      <SocialMediaBtnsContainer>
        <ToastContainer onClick={clickToast}>
          <SocialBtn onClick={likeOrUnlike} disabled={isBlock}>
            {likedUsers.find((ele) => ele._id === currentUserId) && isLogin ? (
              <ThumbUpAltIcon />
            ) : (
              <ThumbUpOffAltIcon />
            )}
          </SocialBtn>
          <LikeNumber>{likedUsers.length}</LikeNumber>
        </ToastContainer>
        <SocialBtn disabled={isBlock}>
          <ShareIcon />
        </SocialBtn>
        <ToastContainer onClick={clickToast}>
          <SocialBtn onClick={saveOrUnsave} disabled={isBlock}>
            {savedUsers.includes(currentUserId) && isLogin ? <BookIcon /> : <ClassOutlinedIcon />}
          </SocialBtn>
        </ToastContainer>
      </SocialMediaBtnsContainer>
      <LikedByContainer>
        {likedUsers.length > 0 && (
          <>
            Liked by{' '}
            <LikedByFirstUserName href={`/user/${likedUsers[0]._id}`}>
              {likedUsers[0].userName}
            </LikedByFirstUserName>{' '}
          </>
        )}
        {likedUsers.length > 1 && (
          <>
            and
            <LinkToListDialog title="Liked By Others" userList={likedUsers.slice(1)}>
              <LikedByOtherUserName>others</LikedByOtherUserName>
            </LinkToListDialog>
          </>
        )}
      </LikedByContainer>
    </SocialMediaRelatedContainer>
  );
};

export default NoteSocialSection;
